import moment from 'moment';

export const HOURS_7_TO_22 = Array.from({ length: 16 }, (_, i) => i + 7);
export const HOURS_7_TO_21 = HOURS_7_TO_22;
export const DAY_H0 = 7;
export const DAY_H1 = 23;
export const DAY_NH = DAY_H1 - DAY_H0;

export const SHIFT_KINDS = [
    { key: 'm', n: 'Утренняя', type: 'day1', work: true, color: 'var(--accent)' },
    { key: 'd', n: 'Дневная', type: 'day2', work: true, color: 'var(--ok)' },
    { key: 'e', n: 'Вечерняя', type: 'evening', work: true, color: 'var(--warn)' },
    { key: 't', n: '2/2', type: 'shift', work: true, color: '#0E8F7E' },
    { key: 's', n: 'Больничный', change: 'ill', work: false, color: 'var(--muted-2)' },
    { key: 'c', n: 'Отмена', change: 'cencel', work: false, color: 'var(--danger-line)' },
    { key: 'p', n: 'Прогул', change: 'absenteeism', work: false, color: 'var(--danger)' },
];

export const SHIFT_PRESETS = [
    { key: 'm', type: 'day1', n: 'Утренняя', start: 7 * 60, end: 16 * 60 },
    { key: 'd', type: 'day2', n: 'Дневная', start: 9 * 60, end: 17 * 60 },
    { key: 'e', type: 'evening', n: 'Вечерняя', start: 15 * 60, end: 23 * 60 },
    { key: 't', type: 'shift', n: '2/2', start: 9 * 60, end: 21 * 60 },
];

export const STATUS_OPTIONS = [
    { id: 'w', n: 'Смена' },
    { id: 'cencel', n: 'Отмена' },
    { id: 'ill', n: 'Больничный' },
    { id: 'absenteeism', n: 'Прогул' },
];

const TYPE_TO_KEY = { day1: 'm', day2: 'd', evening: 'e', shift: 't', nigth: 'e' };
const CHANGE_TO_KEY = { ill: 's', cencel: 'c', absenteeism: 'p' };

export const minutesToTime = (minutes) =>
    moment().startOf('day').add(minutes || 0, 'minutes').format('HH:mm');

export const timeToMinutes = (value) =>
    moment(value, 'HH:mm').diff(moment().startOf('day'), 'minutes');

export const buildTimeOptions = (extraMinutes) => {
    const times = [];
    for (let t = 6 * 60; t <= 23.5 * 60; t += 30) times.push(t);
    if (extraMinutes != null && !times.includes(extraMinutes)) times.push(extraMinutes);
    times.sort((a, b) => a - b);
    return times;
};

export const toWeekInterval = (date) => {
    const startDate = moment(date).startOf('isoWeek');
    return {
        startDate,
        endDate: startDate.clone().add(6, 'days'),
    };
};

export const toMonthInterval = (date) => {
    const month = moment(date).startOf('month');
    return {
        startDate: month.clone(),
        endDate: month.clone().endOf('month'),
        anchor: month.format('YYYY-MM-DD'),
    };
};

export const scheduleRangeForView = (interval, view) => {
    if (view !== 'week') return interval;
    const start = moment(interval.startDate);
    const end = moment(interval.endDate || interval.startDate);
    if (start.isSame(end, 'month')) return toMonthInterval(start);
    return {
        startDate: start.clone().startOf('month'),
        endDate: end.clone().endOf('month'),
    };
};

export const buildShiftMap = (schedule) => {
    const map = {};
    (schedule || []).forEach((item) => {
        const oid = String(operatorIdOf(item.operator) || item.operatorId || '');
        const dateStr = moment((item.schedules && item.schedules[0] && item.schedules[0].date) || item.date).format('YYYY-MM-DD');
        if (oid && dateStr) map[`${oid}|${dateStr}`] = item;
    });
    return map;
};

export const shiftMapOperatorIds = (shiftMap) => {
    const ids = new Set();
    Object.keys(shiftMap).forEach((key) => {
        const sep = key.indexOf('|');
        if (sep > 0) ids.add(key.slice(0, sep));
    });
    return ids;
};

export const weekRangeLabel = (startDate, endDate) => {
    const a = moment(startDate);
    const b = moment(endDate);
    if (a.isSame(b, 'month') && a.isSame(b, 'year')) {
        return `${a.format('D')} — ${b.format('D MMM YYYY')}`;
    }
    if (a.isSame(b, 'year')) {
        return `${a.format('D MMM')} — ${b.format('D MMM YYYY')}`;
    }
    return `${a.format('D MMM YYYY')} — ${b.format('D MMM YYYY')}`;
};

export const monthRangeLabel = (date) => {
    const label = moment(date).format('MMMM YYYY');
    return label.charAt(0).toUpperCase() + label.slice(1);
};

export const dayTitle = (date) => {
    const m = moment(date);
    const dow = m.format('dd');
    return `${dow.charAt(0).toUpperCase()}${dow.slice(1)}, ${m.format('D MMMM YYYY')}`;
};

export const SHIFT_SNAP = 30;
export const SHIFT_MIN_START = 6 * 60;
export const SHIFT_MAX_END = 23.5 * 60;

export const snapMinutes = (value) => Math.round((Number(value) || 0) / SHIFT_SNAP) * SHIFT_SNAP;

export const clampShiftTimes = (start, end) => {
    let s = snapMinutes(start);
    let e = snapMinutes(end);
    s = Math.max(SHIFT_MIN_START, Math.min(s, SHIFT_MAX_END - SHIFT_SNAP));
    e = Math.max(s + SHIFT_SNAP, Math.min(e, SHIFT_MAX_END));
    return { start: s, end: e };
};

export const moveShiftByDelta = (start, end, deltaMin) => {
    const duration = Math.max(SHIFT_SNAP, (end || 0) - (start || 0));
    let s = snapMinutes((start || 0) + deltaMin);
    let e = s + duration;
    if (s < SHIFT_MIN_START) {
        s = SHIFT_MIN_START;
        e = s + duration;
    }
    if (e > SHIFT_MAX_END) {
        e = SHIFT_MAX_END;
        s = e - duration;
    }
    if (s < SHIFT_MIN_START) {
        s = SHIFT_MIN_START;
        e = Math.min(SHIFT_MAX_END, s + duration);
    }
    return { start: s, end: e };
};

export const minutesDeltaFromTrack = (deltaPx, trackWidth) => {
    if (!trackWidth) {
        return 0;
    }
    return (deltaPx / trackWidth) * (DAY_NH * 60);
};

export const barPosition = (startMin, endMin) => {
    const startH = (startMin || 0) / 60;
    const endH = Math.min((endMin || 0) / 60, DAY_H1);
    const left = ((startH - DAY_H0) / DAY_NH) * 100;
    const width = ((endH - Math.max(startH, DAY_H0)) / DAY_NH) * 100;
    return {
        left: `${Math.max(left, 0)}%`,
        width: `${Math.max(width, 0)}%`,
    };
};

export const nowFraction = (now = moment()) => {
    const hours = now.hours() + now.minutes() / 60;
    if (hours < DAY_H0 || hours > DAY_H1) return null;
    return (hours - DAY_H0) / DAY_NH;
};

export const projectOperatorIds = (project) =>
    (project && project.operators ? project.operators : []).map((op) =>
        String(typeof op === 'string' ? op : (op && (op._id || op.id || op)))
    );

export const planForProjectHour = (project, hour) => {
    const daySchedule = project && project.schedule;
    if (!daySchedule) return 0;
    const hourStart = hour * 60;
    const hourEnd = (hour + 1) * 60;
    const scheduleStart = daySchedule.start || 0;
    const scheduleEnd = daySchedule.end || 0;
    if (!(scheduleStart < hourEnd && scheduleEnd > hourStart)) return 0;
    return neededAtHour(daySchedule.needed, hour);
};

export const factForProjectHour = (project, hour, schedule, dateStr) => {
    const ids = new Set(projectOperatorIds(project));
    if (!ids.size || !schedule) return 0;
    const seen = new Set();
    const hourStart = hour * 60;
    const hourEnd = (hour + 1) * 60;
    schedule.forEach((shift) => {
        if (!isWorkShift(shift)) return;
        const shiftDate = moment((shift.schedules && shift.schedules[0] && shift.schedules[0].date) || shift.date).format('YYYY-MM-DD');
        if (shiftDate !== dateStr) return;
        const oid = String(operatorIdOf(shift.operator) || '');
        if (!oid || !ids.has(oid) || seen.has(oid)) return;
        const { start, end } = shiftTimes(shift);
        if (start < hourEnd && end > hourStart) seen.add(oid);
    });
    return seen.size;
};

export const hourCoverageTone = (fact, plan) => {
    if (!plan) return '';
    if (fact >= plan) return 'ok';
    if (fact >= plan * 0.8) return 'w';
    return 'b';
};

export const operatorName = (operator) =>
    (operator && (operator.fullname || operator.name || '').trim()) || 'Без имени';

export const operatorCode = (operator) =>
    (operator && (operator.login || operator.code || '')) || '';

export const matchesOperatorQuery = (operator, query) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return [operator.fullname, operator.name, operator.login, operator.code]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(q));
};

export const shiftKindKey = (shift) => {
    if (!shift) return null;
    if (shift.change && CHANGE_TO_KEY[shift.change]) return CHANGE_TO_KEY[shift.change];
    return TYPE_TO_KEY[shift.type] || 'd';
};

export const isWorkShift = (shift) => {
    if (!shift) return false;
    if (shift.change === 'ill' || shift.change === 'cencel' || shift.change === 'absenteeism') return false;
    return true;
};

export const shiftTimes = (shift) => {
    const slot = shift && shift.schedules && shift.schedules[0];
    return {
        start: slot && slot.start != null ? slot.start : 9 * 60,
        end: slot && slot.end != null ? slot.end : 17 * 60,
    };
};

export const shiftHours = (shift) => {
    if (!isWorkShift(shift)) return 0;
    const { start, end } = shiftTimes(shift);
    return Math.round(Math.max(0, (end - start) / 60) * 10) / 10;
};

export const neededAtHour = (needed, hour) => {
    if (!needed) return 0;
    if (Array.isArray(needed)) return parseInt(needed[hour], 10) || 0;
    if (typeof needed === 'object') {
        return parseInt(needed[hour] != null ? needed[hour] : needed[String(hour)], 10) || 0;
    }
    return 0;
};

export const peakPlanForDay = (campaigns, dayNum) => {
    if (!campaigns || !campaigns.length) return 0;
    let max = 0;
    for (let hour = 7; hour <= 22; hour += 1) {
        let sum = 0;
        campaigns.forEach((campaign) => {
            const daySchedule = campaign.schedule && campaign.schedule[dayNum];
            if (!daySchedule || !daySchedule.needed) return;
            sum += neededAtHour(daySchedule.needed, hour);
        });
        if (sum > max) max = sum;
    }
    return max;
};

export const planForDate = (campaigns, date, holidays = []) => {
    const dateStr = moment(date).format('YYYY-MM-DD');
    const holiday = holidays.find((item) => moment(item.date).format('YYYY-MM-DD') === dateStr);
    let dayNum = moment(date).isoWeekday();
    if (holiday && holiday.scheduleDay) dayNum = Number(holiday.scheduleDay);
    return peakPlanForDay(campaigns, dayNum);
};

export const coverageClass = (fact, plan) => {
    if (!plan) return '';
    if (fact >= plan) return '';
    if (fact >= plan * 0.85) return 'low';
    return 'crit';
};

export const holidayForDate = (holidays, date) => {
    const dateStr = moment(date).format('YYYY-MM-DD');
    return (holidays || []).find((item) => moment(item.date).format('YYYY-MM-DD') === dateStr);
};

export const isNonWorkingDate = (date, holidays = []) => {
    const holiday = holidayForDate(holidays, date);
    if (holiday) {
        if (holiday.type === 'holiday') return true;
        if (holiday.type === 'working_weekend') return false;
    }
    return moment(date).isoWeekday() >= 6;
};

export const monthHourNorm = (anchor, holidays = []) => {
    const start = moment(anchor).startOf('month');
    const end = start.clone().endOf('month');
    let days = 0;
    const cursor = start.clone();
    while (cursor.isSameOrBefore(end, 'day')) {
        if (!isNonWorkingDate(cursor, holidays)) days += 1;
        cursor.add(1, 'day');
    }
    return { days, hours: days * 8 };
};

export const monthTileBar = (startMin, endMin) => {
    const startH = (startMin || 0) / 60;
    const endH = (endMin || 0) / 60;
    const left = Math.max(0, ((startH - 6) / 18) * 100);
    const width = Math.min(100 - left, ((endH - startH) / 18) * 100);
    return {
        left: `${left}%`,
        width: `${Math.max(width, 0)}%`,
    };
};

export const operatorIdOf = (value) => {
    if (!value) return null;
    if (typeof value === 'string') return value;
    return value._id || value.id || value.operatorId || null;
};

export const buildSchedulePayload = ({ operator, date, type, change, start, end, description }) => {
    const op = operator && typeof operator === 'object' ? operator : { _id: operator };
    const dateStr = moment(date).format('YYYY-MM-DD');
    const note = (description || '').trim();
    return {
        operator: operatorIdOf(op),
        date: moment(date).startOf('day'),
        type: type || 'day2',
        place: op.place || 'minsk',
        department: op.department || 'Outbound',
        change: change || undefined,
        description: note || undefined,
        schedules: [{ date: dateStr, start, end }],
    };
};

export default class Utils {
    static itemContent(element) {
        const date = moment(element.schedules[0].date).startOf('day');
        const start = date.clone().add(element.schedules[0].start, 'minutes');
        const end = date.clone().add(element.schedules[0].end, 'minutes');
        let content = `${start.format('HH:mm')} - ${end.format('HH:mm')}`;
        let color;
        let text = '#000000';
        if (element.change) {
            switch (element.change) {
                case 'ill':
                    color = '#FDD835';
                    content = 'БЛ';
                    break;
                case 'cencel':
                    color = '#795548';
                    text = '#ffffff';
                    content = 'Отмена';
                    break;
                case 'absenteeism':
                    color = '#D32F2F';
                    text = '#ffffff';
                    content = 'Прогул';
                    break;
                case 'change':
                    switch (element.type) {
                        case 'day1':
                            color = '#2196F3';
                            break;
                        case 'day2':
                            color = '#4CAF50';
                            break;
                        case 'shift':
                            color = '#5B3FBF';
                            break;
                        case 'evening':
                            color = '#FF9800';
                            break;
                        case 'nigth':
                            color = '#9C27B0';
                            break;
                        default:
                            color = '#2196F3';
                    }
                    break;
                default:
                    color = '#9C27B0';
            }
        } else {
            switch (element.type) {
                case 'day1':
                    color = '#2196F3';
                    break;
                case 'day2':
                    color = '#4CAF50';
                    break;
                case 'shift':
                    color = '#5B3FBF';
                    break;
                case 'evening':
                    color = '#FF9800';
                    break;
                case 'nigth':
                    color = '#9C27B0';
                    break;
                default:
                    color = '#2196F3';
            }
        }
        return { date, color, text, content, operator: element.operator, start, end };
    }

    static options() {
        return {
            places: [{ id: 'minsk', name: 'Минск' }],
            scheduleChange: [
                { name: 'Изменение', id: 'change' },
                { name: 'Отмена', id: 'cencel' },
                { name: 'Больничный', id: 'ill' },
                { name: 'Прогул', id: 'absenteeism' },
            ],
            depatments: [
                { id: 'Inbound', name: 'Входящие' },
                { id: 'Outbound', name: 'Исходящие' },
                { id: 'Finance', name: 'Финансы' },
            ],
            scheduleType: [
                { name: 'Дневная 1', id: 'day1' },
                { name: 'Дневная 2', id: 'day2' },
                { name: '2/2', id: 'shift' },
                { name: 'Вечерняя', id: 'evening' },
                { name: 'Ночная', id: 'nigth' },
            ],
        };
    }

    static formatOperator(operator) {
        return {
            id: operator._id,
            _id: operator._id,
            login: operator.login || '',
            fullname: operator.fullname || '',
            name: operator.login && operator.fullname
                ? `${operator.login} ${operator.fullname}`
                : (operator.login || operator.fullname || 'Неизвестно'),
            department: operator.department,
            place: operator.place,
            status: operator.status,
            role: operator.role || operator.type?.toUpperCase() || 'OPERATOR',
        };
    }

    static getShiftForDate(schedule, operatorId, date) {
        const dateStr = moment(date).format('YYYY-MM-DD');
        const oid = String(operatorIdOf(operatorId) || operatorId || '');
        return schedule.find((item) => {
            const sOperatorId = String(operatorIdOf(item.operator) || item.operatorId || '');
            if (sOperatorId !== oid) return false;
            if (!item.schedules || item.schedules.length === 0) return false;
            return moment(item.schedules[0].date).format('YYYY-MM-DD') === dateStr;
        });
    }
}
